import React, { useContext } from 'react';
import { Tabs } from 'antd';
import { authContext } from '../../store/authStore/AuthContext';
import { BlueLayout, PagesContainerUI, TabsContainer } from '../../styles/styled';
import NmsArchiveComponent from '../NmsMeetingPage/components/NmsArchiveComponent';
import NmsMaterialsComponent from '../NmsMeetingPage/components/NmsMaterialsComponent';

const { TabPane } = Tabs;

export const NmsLkMeetingPage = () => {
  const { state } = useContext(authContext);

  return (
    <PagesContainerUI>
      <BlueLayout>Материалы заседаний</BlueLayout>
      <TabsContainer white>
        <Tabs type="card" tabBarGutter={0}>
          <TabPane tab="Материалы" key="1">
            <NmsMaterialsComponent nms={state.isNms} />
          </TabPane>
          <TabPane tab="Архив" key="2">
            <NmsArchiveComponent nms={state.isNms} />
          </TabPane>
        </Tabs>
      </TabsContainer>
    </PagesContainerUI>
  );
};
